class PredictiveSearchRecommendedProducts extends HTMLElement {
    constructor() {
        super();

        this.products = []
        this.popularProducts = []
        this.staticSuggestions = {
            product: [
                {
                    label: 'Ride The Wave Liquorice 125605 Rug'
                }
            ],
            collection: [
                {
                    label: 'Aurora Rugs'
                },
                {
                    label: 'Galleria Rugs'
                },
                {
                    label: 'Da Vinci Rugs'
                },
                {
                    label: 'Kuza Rugs'
                },
                {
                    label: 'Seville Rugs'
                },
                {
                    label: 'Abstract Rugs'
                },
                {
                    label: 'Tartan Rugs'
                },
                {
                    label: 'Stellar Rugs'
                },
                {
                    label: 'Nourison Rugs',
                    handle: 'nourison'
                },
                {
                    label: 'Balmoral Rugs'
                }
            ],
            shape: [
                {
                    label: 'Hallway & Runner Rugs',
                    handle: 'hall-runners'
                }
            ],
            designer: [
                {
                    label: 'Orla Kiely Rugs',
                    handle: 'orla-kiely'
                }
            ],
            colour: [
                {
                    label: 'Grey Rugs'
                },
                {
                    label: 'Pink Rugs'
                },
                {
                    label: 'Blue Rugs'
                },
                {
                    label: 'Gold Rugs',
                    handle: 'gold-rugs-view-our-top-selection-of-gold-rugs'
                },
                {
                    label: 'Cream Rugs'
                }
            ]
        };
        this.suggestions = []

        this.productsContainer = undefined
        this.suggestionsContainer = undefined


        this.resultsMaxHeight = undefined

        this.mainBody = `
                <div class="predictive-search__result-group">
                
                        <h2 id="predictive-search-recommended-products"
                            class="predictive-search__heading text-body caption-with-letter-spacing">
                            Popular searches
                        </h2>
                          <ul id="predictive-search-results-popular-queries"
                            class="predictive-search__results-list list-unstyled"
                            role="group"
                            aria-labelledby="predictive-search-popular-searches">
                            </ul>
                </div>
                <div class="predictive-search__result-group">
                        <h2 id="predictive-search-recommended-products"
                            class="predictive-search__heading text-body caption-with-letter-spacing">
                            Most Popular
                        </h2>
                        <button class="nav-arrow prev" aria-label="Previous">&lt;</button>
                        <ul id="predictive-search-results-products-list"
                            class="predictive-search__results-list list-unstyled"
                            role="group"
                            aria-labelledby="predictive-search-products">

                        </ul>
                        <button class="nav-arrow next" aria-label="Next">&gt;</button>
                </div>`

        this.parentPredictiveSearch = this.closest('predictive-search')

        this.currencySymbol = this.dataset.currencySymbol;
    }

    connectedCallback() {
        this.init()
        this.addNavigationListeners();
    }

    productModule(product) {

        let moduleNode = document.createElement('div')
        moduleNode.className = 'predictive-search__product-module'

        moduleNode.innerHTML = `
                    <a href="/products/${product.handle}"
                       class="predictive-search__item predictive-search__item--link-with-thumbnail link link--text"
                       tabindex="-1">
                        <img class="predictive-search__image"
                             src="${product.images[0]}"
                             alt="${product.title}" width="50"
                             height="73.19304666056725">
                        <div class="predictive-search__item-content">
                            <p class="predictive-search__item-heading h5">${product.title}</p>
                            <div class="price ${product.discount > 0 ? 'price--on-sale' : ''}">
                                <div>
                                    <div class="price__regular">
                                        <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                        <span class="price-item price-item--regular">${product.price_min !== product.price_max ? 'from ' : ''}${this.currencySymbol + product.price_min}</span>
                                    </div>
                                    <div class="price__sale">
                                        <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                        <span>
                                        <s class="price-item price-item--regular">${product.compare_at_price}</s>
                                        </span>
                                                                            <span class="visually-hidden visually-hidden--inline">Sale price</span>
                                                                            <span class="price-item price-item--sale price-item--last">from ${this.currencySymbol + product.price_min}</span>
                                                                        </div>
                                                                        <small class="unit-price caption hidden">
                                                                            <span class="visually-hidden">Unit price</span>
                                                                            <span class="price-item price-item--last">
                                        <span></span>
                                        <span aria-hidden="true">/</span>
                                        <span class="visually-hidden">&nbsp;per&nbsp;</span>
                                        <span></span>
                                        </span>
                                    </small>
                                </div>
                            </div>
                        </div>
                    </a>`

        return moduleNode
    }

    queryModule(item) {

        let moduleNode = document.createElement('div')
        moduleNode.className = 'predictive-search__query-module'

        let category
        if (item.reference === 'product') {
            category = 'products'
        } else {
            category = 'collections'
        }

        const queryUrl = '/' + category + '/' + (item.handle ? item.handle : this.handlize(item.label))

        moduleNode.innerHTML = `
                                <li id="predictive-search-option-query-{{ data }}"
                                    class="predictive-search__list-item"
                                    role="option" aria-selected="false">
                                    <a href="${queryUrl}"
                                       class="predictive-search__item link link--text"
                                       tabindex="-1">
                                        <div class="predictive-search__item-content predictive-search__item-content--centered">
                                            <p class="predictive-search__item-heading predictive-search__item-query-result h5"
                                               aria-label="{{ data }}">
                                                <mark>${item.label}</mark>
                                            </p>
                                        </div>
                                    </a>
                                </li>`

        return moduleNode
    }

    setMaxHeight() {
        this.resultsMaxHeight = window.innerHeight - document.querySelector('.section-header').getBoundingClientRect().bottom;
        this.closest('.predictive-search--header').style.setProperty('max-height', this.resultsMaxHeight + 'px')
    }

    async init() {
        this.parentPredictiveSearch.setAttribute('loading', true)
        this.innerHTML = this.mainBody
        this.productsContainer = this.querySelector('#predictive-search-results-products-list')
        this.suggestionsContainer = this.querySelector('#predictive-search-results-popular-queries')

        await fetch('/collections/all?view=json&sort_by=best-selling')
            .then(res => res.json())
            .then(data => {
                this.products = data.products
            })

        this.popularProducts = this.products.filter(product => product.id !== 7862401007835 && product.id !== 7505769955547).slice(0, 10)
        this.popularProducts.forEach(product => {
            this.productsContainer.append(this.productModule(product))
        })

        //getting the first 10 random products but this is arbitrary;
        // 10 should be enough to cover the remaining suggestions slots, if needed.
        //it also deepends on the number of total entries desired
        // (which is the second parameter of the generateQueryResults fucntion
        // - here omitted to use the default value, 8).
        this.suggestions = this.generateQueryResults(this.getRandomItems(this.products.slice(10), 10))
        this.suggestions.forEach(query => {
            this.suggestionsContainer.append(this.queryModule(query))
        })

        this.parentPredictiveSearch.removeAttribute('loading')
    }

    addNavigationListeners() {
        const prevButton = this.querySelector('.nav-arrow.prev');
        const nextButton = this.querySelector('.nav-arrow.next');
        const productList = this.querySelector('#predictive-search-results-products-list');

        prevButton.addEventListener('click', () => {
            productList.scrollBy({
                left: -170,
                behavior: 'smooth'
            });
        });

        nextButton.addEventListener('click', () => {
            productList.scrollBy({
                left: 170,
                behavior: 'smooth'
            });
        });
    }

    getRandomItems(arr, count) {
        const shuffled = arr.slice().sort(() => 0.5 - Math.random());
        return shuffled.slice(0, count);
    }

    getCurrentDate() {
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    generateQueryResults(productList, totalEntries = 8) {
        const localStorageKey = 'mixedEntries';
        const storedData = JSON.parse(localStorage.getItem(localStorageKey));
        const currentDate = this.getCurrentDate();

        if (storedData && storedData.date === currentDate && storedData.result.length === totalEntries) {
            return storedData.result;
        }

        const totalNonProductItems = this.staticSuggestions.collection.length + this.staticSuggestions.shape.length + this.staticSuggestions.designer.length + this.staticSuggestions.colour.length;
        const proportions = {
            collection: this.staticSuggestions.collection.length / totalNonProductItems,
            shape: this.staticSuggestions.shape.length / totalNonProductItems,
            designer: this.staticSuggestions.designer.length / totalNonProductItems,
            colour: this.staticSuggestions.colour.length / totalNonProductItems
        };

        const entriesNeeded = {
            collection: Math.max(1, Math.round(proportions.collection * (totalEntries - 1))),
            shape: Math.max(1, Math.round(proportions.shape * (totalEntries - 1))),
            designer: Math.max(1, Math.round(proportions.designer * (totalEntries - 1))),
            colour: Math.max(1, Math.round(proportions.colour * (totalEntries - 1)))
        };

        let totalCalculatedEntries = Object.values(entriesNeeded).reduce((a, b) => a + b, 0);

        // Adjust to ensure totalCalculatedEntries matches totalEntries - 1
        while (totalCalculatedEntries > totalEntries - 1) {
            for (const key of Object.keys(entriesNeeded)) {
                if (entriesNeeded[key] > 1) {
                    entriesNeeded[key]--;
                    totalCalculatedEntries--;
                    if (totalCalculatedEntries <= totalEntries - 1) break;
                }
            }
        }

        while (totalCalculatedEntries < totalEntries - 1) {
            for (const key of Object.keys(entriesNeeded)) {
                entriesNeeded[key]++;
                totalCalculatedEntries++;
                if (totalCalculatedEntries >= totalEntries - 1) break;
            }
        }

        let mixedEntries = [];

        // Add at least one entry from each category
        Object.keys(entriesNeeded).forEach(reference => {
            const items = this.staticSuggestions[reference];
            let randomItems = this.getRandomItems(items, entriesNeeded[reference]);
            randomItems = randomItems.map(randomItem => ({reference, ...randomItem}));

            mixedEntries.push(...randomItems);
        });

        //add suggested product
        mixedEntries.push({reference: 'product', ...this.staticSuggestions['product'][0]})

        // Add fetched products
        let productIndex = 0;
        while (productIndex < productList.length && mixedEntries.length < totalEntries) {
            const productObject = {
                label: productList[productIndex++]['title'],
                url: '/' + productList[productIndex++]['handle']
            }
            mixedEntries.push(productObject);
        }

        // If not enough products, fill with other category items
        if (mixedEntries.length < totalEntries) {
            Object.keys(this.staticSuggestions).forEach(reference => {
                if (reference !== 'product') {
                    const remainingItems = this.staticSuggestions[reference].filter(item => !mixedEntries.includes(item));
                    const itemsToAdd = totalEntries - mixedEntries.length;
                    mixedEntries.push(...this.getRandomItems(remainingItems, itemsToAdd));
                }
            });
        }

        //shuffle the final array
        mixedEntries = this.getRandomItems(mixedEntries, mixedEntries.length)

        const result = mixedEntries;

        localStorage.setItem(localStorageKey, JSON.stringify({result, date: currentDate}));

        return result;
    }

    handlize(str) {
        return str
            .toLowerCase() // Convert to lowercase
            .trim() // Remove whitespace from both ends
            .replace(/[^a-z0-9\s-]/g, '') // Remove non-alphanumeric characters except spaces and hyphens
            .replace(/\s+/g, '-') // Replace spaces with hyphens
            .replace(/-+/g, '-') // Replace multiple hyphens with a single hyphen
            .replace(/^-+|-+$/g, ''); // Remove leading and trailing hyphens
    }

}

customElements.define('predictive-search-recommended-products', PredictiveSearchRecommendedProducts)